// extracted by mini-css-extract-plugin
export default {"copyToClipboardBtn":"CopyToClipBoard_copyToClipboardBtn__Vxh5m","copyToClipboardImage":"CopyToClipBoard_copyToClipboardImage__FUOAj"};